
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { setIslemKayitItemReqResData } from "../../../features/admin3/admin3Slice";
import { showModal } from "../../../features/modal/modalSlice";

const Container = styled.table`
        width: 100%;
        border-collapse: collapse;

        thead{
            margin-bottom: 20px;
            border-bottom: 10px solid ${({theme}) => theme.mainBgColor};


            th{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

        }

        tbody{


            tr{
                border-bottom: 20px solid ${({theme}) => theme.mainBgColor};
                background-color: ${({theme}) => theme.secondaryBgColor};
                td{
                    text-align: center;
                    padding: 15px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                }

                .underline{
                    text-decoration: underline;
                    color: var(--color-main);
                    font-weight: var(--font-weight-lg);
                    cursor: pointer;
                }
            }
        }
`;

const titles = [
    "IP Adresi",
    "Üye",
    "Tarih",
    "API Adresi",
    "İstek (Request) Verisi",
    "Cevap (Response) Verisi"
];


const IslemKayitlariTable = ({ list }) => {
  const dispatch = useDispatch();
  return (
    <Container>
      <thead>
          <tr>
              {
                  titles.map((item) => (
                      <th>{item}</th>
                  ))
              }
          </tr>
      </thead>
      <tbody>
          {
              list.map((item) => (
                  <tr>
                    <td>{item.ipAddress}</td>
                    <td>{item.user}</td>
                    <td>{moment(item.timeStamp).format('LLL')}</td>
                    <td>{item.path}</td>
                    <td className="underline" onClick={() => {dispatch(setIslemKayitItemReqResData({type: "req", data: item.requestBody})); dispatch(showModal("islemKayitItemReqRes"))}}>İstek verisini görüntüle</td>
                    <td className="underline" onClick={() => {dispatch(setIslemKayitItemReqResData({type: "res", data: item.responseBody})); dispatch(showModal("islemKayitItemReqRes"))}}>Cevap verisini görüntüle</td>
                  </tr>
              ))
          }
      </tbody>
    </Container>
  );
};

export default IslemKayitlariTable